import ImageMergeModal from '@/components/admin/ImageManager/ImageMergeModal/ImageMergeModal';

export default ImageMergeModal;
